import PropTypes from 'prop-types';
import React from 'react';
import Portal from '../Portal';
import usePopupMenu from './PopupMenu.hook';
import PopUpMenuArrow from './PopupMenuArrow';

const PopupMenuMenu = ({ placement = 'bottom', children, onClick, ...props }) => {
  const { arrow, popup, backdrop, isVisible } = usePopupMenu(placement);

  const handleClick = e => {
    e.stopPropagation();
    onClick();
  };

  if (!isVisible) return null;

  return (
    <Portal>
      <div
        data-component="PopupMenuBackdrop"
        className="fixed inset-0 z-popup-backdrop"
        {...backdrop}
      />
      {/* eslint-disable-next-line */}
      <div data-component="PopupMenuMenu" onClick={handleClick} {...props} {...popup}>
        <PopUpMenuArrow {...arrow} />
        <nav
          style={
            popup && popup.style && popup.style.maxWidth && { maxWidth: popup.style.maxWidth - 10 }
          }
          className="relative rounded-lg overflow-hidden"
        >
          {children}
        </nav>
      </div>
    </Portal>
  );
};

PopupMenuMenu.propTypes = {
  placement: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
  children: PropTypes.node,
  onClick: PropTypes.func,
};

PopupMenuMenu.defaultProps = {
  onClick: () => {},
};

export default PopupMenuMenu;
